<div class="column">
  <div class="title">
    @if (mobile) {
      <app-icon-button (click)="back()" colorVariant="secondary-dark" icon="arrow_back" size="small"/>
    }
    <div class="typo-h1">{{ "booking.login.title" | transloco }}</div>
  </div>

  <app-login/>
</div>
